import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/layout';
export const _frontmatter = {
  "title": "Queries"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Queries`}</h1>
    <p><em parentName="p"><strong parentName="em">{`Work in progress`}</strong>{`: This page still needs to be written.`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      